import { yup } from '@aibees/shared/utils';
import { EMPTY_MEMBER_DATA } from '../../constants';
import type { AddMemberFormData } from './types';

export const schema = yup.object().shape({
  members: yup
    .array()
    .of(
      yup.object().shape({
        firstName: yup
          .string()
          .max(49, 'Maximum of 50 characters.')
          .required('First Name is required'),

        lastName: yup
          .string()
          .max(49, 'Maximum of 50 characters.')
          .required('Last Name is required'),
        username: yup
          .string()
          .email('Email must be a valid email address')
          .required('Email is required'),
        type: yup.string().required().required('Role is required') as any,
      })
    )
    .distinctOnProperty(
      'username',
      'Each invited member must have a unique email.'
    ),
});

export const defaultValues: AddMemberFormData = {
  members: [EMPTY_MEMBER_DATA],
};
